import { render, staticRenderFns } from "./TicketDescription.vue?vue&type=template&id=36caf3d5&scoped=true"
import script from "./TicketDescription.vue?vue&type=script&lang=js"
export * from "./TicketDescription.vue?vue&type=script&lang=js"
import style0 from "./TicketDescription.vue?vue&type=style&index=0&id=36caf3d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36caf3d5",
  null
  
)

export default component.exports